import React, { useState } from 'react';
import { Lock, Loader2 } from 'lucide-react';
import { adminLogin, formatApiErrorDetail } from '@/utils/adminApi';
import { ADMIN_COLORS as C } from '@/components/admin/AdminPage';

const ERRORS = {
  401: 'البريد الإلكتروني أو كلمة السر غير صحيحة',
  429: 'محاولات كثيرة خاطئة. حاول مجدداً بعد 15 دقيقة',
};

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onLogin(await adminLogin(email, password));
    } catch (err) {
      const status = err.response?.status;
      setError(ERRORS[status] || formatApiErrorDetail(err.response?.data?.detail) || 'تعذّر الاتصال، حاول مجدداً');
    }
    setBusy(false);
  };

  const input = {
    background: C.field, border: `1px solid ${C.border}`, color: C.primary, fontSize: 15,
  };
  return (
    <form onSubmit={submit} className="max-w-sm mx-auto pt-24 px-5" data-testid="admin-login-form">
      <div className="flex items-center gap-2 mb-2">
        <Lock size={22} color={C.accent} />
        <h1 className="text-2xl font-bold">صفحة فلك الخاصة</h1>
      </div>
      <p className="mb-6 text-sm" style={{ color: C.muted }}>سجّل الدخول للوصول إلى مولّد إعلانات الهلال.</p>
      <label className="block text-sm mb-1" style={{ color: C.secondary }} htmlFor="admin-email">البريد الإلكتروني</label>
      <input id="admin-email" type="email" dir="ltr" required value={email} onChange={(e) => setEmail(e.target.value)}
        className="w-full rounded-lg px-3 py-2.5 mb-4 outline-none" style={input} data-testid="admin-login-email" />
      <label className="block text-sm mb-1" style={{ color: C.secondary }} htmlFor="admin-password">كلمة السر</label>
      <input id="admin-password" type="password" dir="ltr" required value={password} onChange={(e) => setPassword(e.target.value)}
        className="w-full rounded-lg px-3 py-2.5 mb-4 outline-none" style={input} data-testid="admin-login-password" />
      {error && <div className="mb-4 text-sm" style={{ color: '#FCA5A5' }} data-testid="admin-login-error">{error}</div>}
      <button type="submit" disabled={busy} className="w-full rounded-xl py-3 font-bold flex justify-center items-center gap-2"
        style={{ background: C.accent, color: C.accentInk, opacity: busy ? 0.7 : 1 }} data-testid="admin-login-submit">
        {busy && <Loader2 size={16} className="animate-spin" />}
        دخول
      </button>
    </form>
  );
};
